import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function MessagesTab() {
  const [msgs, setMsgs] = useState([]);
  useEffect(() => { api.get("/admin/messages").then((r) => setMsgs(r.data)); }, []);
  if (!msgs.length) return <p data-testid="admin-messages-empty" className="text-sm text-[var(--mm-muted)]">No messages yet.</p>;
  return (
    <div data-testid="admin-messages-tab" className="space-y-4">
      {msgs.map((m) => (
        <div key={m.id} className="border border-[var(--mm-line)] p-5">
          <div className="flex justify-between gap-4 flex-wrap">
            <p className="text-sm font-semibold">{m.name} · <a href={`mailto:${m.email}`} className="text-[var(--mm-red)]">{m.email}</a></p>
            <p className="text-xs text-[var(--mm-muted)]">{new Date(m.created_at).toLocaleString("en-GB")}</p>
          </div>
          {m.subject && <p className="eyebrow mt-2">{m.subject}</p>}
          <p className="text-sm mt-2 whitespace-pre-line">{m.message}</p>
        </div>
      ))}
    </div>
  );
}
